import type { ReactNode } from 'react';
import { Box, Stack, Tooltip, Typography } from 'ui';
import { InfoOutlined } from 'ui/icons';

const itemVariants = {
  bold: { fontWeight: 'bold' },
  standard: { fontWeight: 'normal' },
};

export const MaterialBreakdownItem = ({
  label,
  value,
  secondaryValue,
  variant = 'standard',
  tooltipContent,
  'data-testid': dataTestId,
}: {
  label: ReactNode;
  value?: ReactNode;
  secondaryValue?: ReactNode;
  variant?: 'standard' | 'bold';
  tooltipContent?: ReactNode;
  'data-testid'?: string;
}) => {
  const { fontWeight } = itemVariants[variant];

  return (
    <Box
      sx={({ palette }) => ({
        alignItems: 'center',
        borderBottom: `1px solid ${palette.border.main}`,
        display: 'flex',
        gap: 3,
        justifyContent: 'space-between',
        ml: variant === 'standard' ? 2 : 0,
        py: 0.5,
      })}
      data-testid={dataTestId}
    >
      <Stack direction="row" spacing={1} alignItems="center">
        <Typography variant="body2" noWrap fontWeight={fontWeight}>
          {label}
        </Typography>
        {tooltipContent ? (
          <Tooltip title={tooltipContent} placement="top">
            <InfoOutlined fontSize="small" />
          </Tooltip>
        ) : null}
      </Stack>
      {value ? (
        <Typography
          variant="body2"
          component="span"
          fontWeight={fontWeight}
          width={secondaryValue ? '120px' : 'auto'}
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <Typography component="span" variant="inherit">
            {value}
          </Typography>
          {secondaryValue ? (
            <Typography component="span" variant="inherit">
              {secondaryValue}
            </Typography>
          ) : null}
        </Typography>
      ) : null}
    </Box>
  );
};
